import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import get from 'lodash/get';
export default {
  name: 'ViewAccountMgmtAccountMgmtSuperAdminTerminal',
  mixins: [tenantPickerMixin],
  data: function data() {
    return {
      callPath: 'abac.debugCacheClear',
      params: '{}',
      isLoading: false,
      errorResponse: null,
      validResponse: null,
      availableActions: [],
      modules: [],
      loadingModules: false,
      moduleTogglePrompt: false,
      moduleToToggle: null,
      moduleDoDelete: false,
      rules: [],
      ruleDeletePrompt: false,
      ruleDeleteObj: null
    };
  },
  computed: {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    jsonRule: function jsonRule() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('Common.fieldRequired');
      }, function (v) {
        try {
          JSON.parse(v);
        } catch (error) {
          return 'INVALID JSON';
        }

        return true;
      }];
    },
    buttons: function buttons() {
      return [{
        title: 'EXEC ACTION',
        icon: 'fal fa-wand-magic',
        action: 'execAction',
        valid: !this.isLoading
      }];
    }
  },
  mounted: function mounted() {
    this.fetchModules();
    this.fetchActions();
  },
  methods: {
    fetchActions: function fetchActions() {
      var _this3 = this;

      return ApiService.execConsoleAction('$node.actions', {
        skipInternal: true,
        onlyAvailable: true
      }).then(function (data) {
        _this3.availableActions = data.map(function (action) {
          action.params = get(action, 'action.params') || {};
          return action;
        }).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    fetchModules: function fetchModules() {
      var _this4 = this;

      Promise.all([ApiService.execConsoleAction('abac.fetchModules', {}), ApiService.fetchRules()]).then(function (data) {
        _this4.modules = data[0];
        _this4.loadingModules = false;
        _this4.rules = data[1].filter(function (r) {
          return get(r, 'subject[0]', '').toLowerCase() !== 'all' || get(r, 'actions[0]', '').toLowerCase() !== 'manage';
        }).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    toggleModule: function toggleModule(key, doDelete) {
      var _this5 = this;

      return ApiService.execConsoleAction('abac.removeModule', {
        moduleKey: key,
        doDelete: doDelete
      }).then(function () {
        _this5.fetchModules();
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    deleteRule: function deleteRule(ruleId) {
      var _this6 = this;

      return ApiService.execConsoleAction('abac.deleteRule', {
        id: ruleId
      }).then(function () {
        _this6.fetchModules();
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    execAction: function execAction() {
      var _this7 = this;

      this.errorResponse = null;
      this.validResponse = null;
      this.isLoading = true;

      try {
        var params = JSON.parse(this.params);
        return ApiService.execConsoleAction(this.callPath.trim(), params).then(function (res) {
          if (typeof res === 'string') {
            _this7.validResponse = res;
          } else {
            _this7.validResponse = JSON.stringify(res, null, 1);
          }
        }).catch(function (error) {
          _this7.errorResponse = "".concat(error);

          if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
            _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
          } else {
            _this7.$snack(_this7.$i18n_t('Common.oops1'), 'error');
          }
        }).finally(function () {
          _this7.isLoading = false;
        });
      } catch (error) {
        this.errorResponse = "".concat(error);
        this.isLoading = false;
      }
    }
  }
};